import { createAction, union } from "@ngrx/store";
import { Integration } from "voxloud-types/dist/models/integrations";
import { AccountTokens, ChatData, SessionDTO, SipCredentials, SubscriptionLite } from '../states-models/account.state.model';
import { Pbx } from "voxloud-types/dist/models";
import { SmsConfigResponse } from 'voxloud-types/dist/models'

export const saveTokens = createAction(
  "[Account Auth] Save Tokens",
  (tokens: AccountTokens) => ({ tokens })
);

export const saveUsername = createAction(
  "[Account] Save Username",
  (username: string) => ({ username })
);

export const savePbxAndCompanyIds = createAction(
  "[Account] Save pbx & company ids",
  (pbxId: string, companyId: string) => ({ pbxId, companyId })
);

export const saveSubscription = createAction(
  "[Account] Save subscription",
  (subscription: SubscriptionLite) => ({ subscription })
);

export const saveSession = createAction(
  '[Account] Save Session',
  (session: SessionDTO) => ({ session })
);

export const saveOutboundNumber = createAction(
  '[Account] Save Outbound Number',
  (number: string) => ({ number })
);

export const saveSipCredentials = createAction(
  "[Account] Save SIP Credentials",
  (sipCredentials: SipCredentials) => ({ sipCredentials })
);

export const logout = createAction(
  "[Account] Logout"
);

export const saveUserInfo = createAction(
  "[Account] Save User Info",
  (userInfo: any) => ({userInfo})
);

export const SavePbx = createAction(
  "[Account] Save PBX",
  (pbx: Pbx) => ({pbx})
);

export const saveSmsConfig = createAction(
  '[Account] Save SMS Config',
  (smsConfig: SmsConfigResponse) => ({ smsConfig })
);

export const setChatData = createAction(
  '[Account] Save Chat Data',
  (chatData: ChatData) => ({chatData})
)


const actions = {
  saveTokens,
  saveUsername,
  savePbxAndCompanyIds,
  saveSession,
  saveOutboundNumber,
  saveSipCredentials,
  saveSubscription,
  saveUserInfo,
  SavePbx,
  saveSmsConfig,
  setChatData,
  logout
};

const accountActions = union(actions);

export type AccountActions = typeof accountActions;
